"use client"

// Formateur KIDSHAKER sans mot de passe : il tape son identifiant @tuteur.ai et reçoit sur WhatsApp
// un lien qui le connecte en un clic. Réponse identique que le compte existe ou non.
import type React from "react"
import { useState } from "react"
import Link from "next/link"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"

export default function ConnexionFormateurPage() {
  const [identifiant, setIdentifiant] = useState("")
  const [envoi, setEnvoi] = useState(false)
  const [message, setMessage] = useState<string | null>(null)

  const demander = async (e: React.FormEvent) => {
    e.preventDefault()
    setEnvoi(true)
    try {
      const res = await fetch("/api/auth/formateur-lien", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ identifiant }),
      })
      const data = await res.json().catch(() => null)
      setMessage(data?.message ?? "Si cet identifiant correspond à un compte formateur, un lien vient de partir sur WhatsApp.")
    } catch {
      setMessage("Une erreur est survenue. Réessaie dans un instant.")
    } finally {
      setEnvoi(false)
    }
  }

  return (
    <div className="flex min-h-svh w-full items-center justify-center p-6 md:p-10 bg-gradient-to-br from-blue-50 to-indigo-50">
      <div className="w-full max-w-md">
        <Card>
          <CardHeader>
            <CardTitle className="text-2xl">Je n&apos;ai plus mon mot de passe</CardTitle>
            <CardDescription>
              Espace formateur KIDSHAKER. Tape ton identifiant : tu reçois sur WhatsApp un lien qui t&apos;ouvre ta classe
              en un clic.
            </CardDescription>
          </CardHeader>
          <CardContent>
            {message ? (
              <div className="flex flex-col gap-4">
                <p className="rounded-md bg-green-50 p-3 text-sm text-green-900 border border-green-200">{message}</p>
                <p className="text-xs text-muted-foreground">
                  Le lien reste valable 2 heures. Rien reçu ? Préviens l&apos;équipe KIDSHAKER au 01 59 48 28 08.
                </p>
              </div>
            ) : (
              <form onSubmit={demander} className="flex flex-col gap-4">
                <div className="grid gap-2">
                  <Label htmlFor="identifiant">Identifiant</Label>
                  <Input
                    id="identifiant"
                    type="text"
                    autoComplete="username"
                    placeholder="prenom.nom@tuteur.ai"
                    required
                    value={identifiant}
                    onChange={(e) => setIdentifiant(e.target.value)}
                  />
                </div>
                <Button type="submit" className="w-full" disabled={envoi}>
                  {envoi ? "Envoi..." : "Recevoir mon lien sur WhatsApp"}
                </Button>
              </form>
            )}
            <div className="mt-4 text-center text-sm">
              <Link href="/auth/login" className="underline underline-offset-4 text-indigo-600">
                Retour à la connexion
              </Link>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
